import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from '../components/global/Sidebar';
import Topbar from '../components/global/Topbar';
import { useSelector } from 'react-redux';
import { Alert, Snackbar } from '@mui/material';
import { adminAuth } from './adminAuth';
import '../App.css';

const AuthLayout = ({ children }) => {
    const isAdminAuth = adminAuth();

    const navigate = useNavigate();

    // snackbar
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    // useEffect(() => {
    //     if (true) {
    //         setSnackbarMessage('Please connect / login');
    //         setSnackbarSeverity('warning');
    //         setSnackbarOpen(true);
    //     }
    // }, []);
    // Function to update the title based on outlet selection (from Sidebar)

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    useEffect(() => {
        if (!isAdminAuth) {
            navigate('/');
        }
    }, [isAdminAuth, navigate]);
    return (
        <>
            {isAdminAuth ? (
                <div className="app">
                    <Sidebar
                        style={{ position: 'absolute' }}
                        className="sidebar"
                    />
                    <main className="content">
                        <Topbar />
                        <Outlet />
                    </main>
                </div>
            ) : (
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={handleCloseSnackbar}
                >
                    <Alert
                        elevation={6}
                        onClose={handleCloseSnackbar}
                        severity={snackbarSeverity}
                    >
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            )}
        </>
    );
};

export default AuthLayout;
